// extracted by mini-css-extract-plugin
var _1 = "DocFlowEpostValidationPreviewModal-modulecontentWrapper__WxRbm Content-modulecontentWrapper__p1AMw";
var _2 = "DocFlowEpostValidationPreviewModal-modulesection__oZsoF";
var _3 = "DocFlowEpostValidationPreviewModal-modulesectionTitle__kB2VH";
var _4 = "DocFlowEpostValidationPreviewModal-moduleskeleton__7fgzT Skeleton-moduleSkeleton__Mlrfv";
export { _1 as "contentWrapper", _2 as "section", _3 as "sectionTitle", _4 as "skeleton" }
